import axios from 'axios';
import { getTokenFromCookie } from '../utils/tokenHelper';

/**
 * Get application data from analytics API
 */
export const getApplicationFromAnalytics = async (applicantGuid: string) => {
    try {
        const token = getTokenFromCookie();
        const response = await axios.get(`/api/v1/analytics/application/${applicantGuid}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error: any) {
        console.log('Error fetching application from analytics:', error);
        
        // Re-throw the error so calling code can handle specific cases (404, 500, etc.)
        throw error;
    }
};

/**
 * Analytics Service object with all methods
 */
export const AnalyticsService = {
    getApplicationFromAnalytics
};

// Default export for convenience
export default AnalyticsService;